import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  scrollTo?: string;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  scrollTo,
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-semibold transition-all duration-300 ease-in-out text-center shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-cream rounded-sm';
  const variants = {
    primary: 'bg-burgundy text-white hover:bg-burgundy-light border-2 border-burgundy hover:border-burgundy-light focus:ring-burgundy',
    secondary: 'bg-transparent text-burgundy border-2 border-burgundy hover:bg-burgundy hover:text-white focus:ring-burgundy'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else if (scrollTo) {
      document.getElementById(scrollTo)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    onClick?.(e);
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} onClick={handleClick} {...props} data-id="element-209">
      {children}
    </button>;
}